import { Injectable } from '@angular/core';
import { ProgressStep } from '../../model/progress-step.model';
import { ProgressState } from '../../model/progress-state.enum';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  private steps: ProgressStep[];

  public get Steps(): ProgressStep[] {
    return this.steps;
  }

  public HasLastStep = false;

  constructor() {
    this.steps = new Array();
  }

  public HasStep(name: string): boolean {
    return this.steps.findIndex(step => step.name === name) != -1;
  }

  public GetStep(name: string): ProgressStep {
    return this.steps.find(step => step.name === name);
  }

  public AddStep(name: string, title: string): ProgressStep {
    let step = this.GetStep(name);

    if (step === undefined) {
      step = new ProgressStep(name, title);
      this.steps.push(step);
    }

    return step;
  }

  public RemoveStep(name: string): ProgressStep[] {
    const index = this.steps.findIndex(step => step.name === name);
    if (index !== -1) {
      return this.steps.splice(index, 1);
    }
  }

  public SetState(name: string, state: ProgressState): ProgressStep {
    const step = this.GetStep(name);
    if (step) {
      step.state = state;
    }
    return step;
  }

  public SetActive(name: string) {
    const index = this.steps.findIndex(step => step.name === name);
    if (index !== -1) {
      // For a step to be in-progress, all the steps before it should be completed
      // and all the steps after should be pending
      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].state = i < index ? ProgressState.Completed : ProgressState.Pending;
      }

      this.steps[index].state = ProgressState.InProgress;
   }
  }

  public Clear(): void {
    this.steps = [];
  }
}
